"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverComponent = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
function HoverComponent(props) {
    const [isHovered, setHover] = react_1.default.useState(false);
    const onMouseEnter = () => setHover(true);
    const onMouseLeave = () => setHover(false);
    return (react_1.default.createElement("div", { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, title: props.altText }, isHovered ? props.hoverElement : props.normalElement));
}
exports.HoverComponent = HoverComponent;
//# sourceMappingURL=HoverComponent.js.map